import { render, staticRenderFns } from "./EmployeesConfigure.vue?vue&type=template&id=c6baaf80&scoped=true&"
import script from "./EmployeesConfigure.vue?vue&type=script&lang=js&"
export * from "./EmployeesConfigure.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesConfigure.vue?vue&type=style&index=0&id=c6baaf80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6baaf80",
  null
  
)

export default component.exports